import AttestationList from "../../components/attestations/AttestationList";

const AttestationPage = () => {
   return <AttestationList />;
}

export default AttestationPage;